import React from 'react';

import MarketingOptIn from '@rover/react-lib/src/components/modals/MarketingOptIn';
import ScrollToTopOnMount from '@rover/react-lib/src/components/utils/ScrollToTopOnMount';
import LandingRoverProtect from '@rover/react-lib/src/pages/landing/components/LandingRoverProtect';
import Footer from '@rover/react-lib/src/pages/shared/FooterLinks/Footer';
import { BrandLocalityServiceCitiesItem } from '@rover/rsdk/src/apiClient/latest/model/brandLocalityServiceCitiesItem';
import type { CountryFooterLink } from '@rover/rsdk/src/apiClient/latest/model/countryFooterLink';
import type { PaginatedCountryRegionLinkList } from '@rover/rsdk/src/apiClient/latest/model/paginatedCountryRegionLinkList';
import type { HomepageMetaTags } from '@rover/types/src/HomepageConfiguration';

import AppStoreCallout from '../../shared/AppStoreCallout/AppStoreCallout';
import { HomePageLayout } from '../common/styles';

import HomePageFaqs from './components/HomePageFaqs';
import HomePageHero from './components/HomePageHero';
import HomePageHowBrandWorks from './components/HomePageHowBrandWorks';
import RoverTestimonials from './components/RoverTestimonials';
import ServicesForEveryPet from './components/ServicesForEveryPet';
import HtmlHeader from './HtmlHeader';

type Props = {
  citiesAndNeighborhoodsLinks?: BrandLocalityServiceCitiesItem[];
  countryFooterLinks?: CountryFooterLink[];
  countryRegionLinks: PaginatedCountryRegionLinkList;
  roverGuaranteeLink?: string;
  metaTags: HomepageMetaTags;
  cxOperatingHours?: string;
};

const DefaultBrandHomePageTemplate = ({
  metaTags: { title, metaDescription },
  citiesAndNeighborhoodsLinks,
  countryFooterLinks,
  countryRegionLinks,
  roverGuaranteeLink,
  cxOperatingHours,
}: Props): JSX.Element => {
  return (
    <>
      <HtmlHeader title={title} metaDescription={metaDescription} />
      <ScrollToTopOnMount />
      <HomePageHero />
      <MarketingOptIn />
      <HomePageLayout>
        <ServicesForEveryPet />
      </HomePageLayout>

      <LandingRoverProtect mt={['12x', '12x']} mb={['16x', '20x']} />

      <HomePageLayout>
        <RoverTestimonials />
      </HomePageLayout>

      <HomePageHowBrandWorks />

      {roverGuaranteeLink && cxOperatingHours && (
        <HomePageFaqs
          mt={['16x', '24x']}
          pb={['16x', '24x']}
          roverGuaranteeLink={roverGuaranteeLink}
          cxOperatingHours={cxOperatingHours}
        />
      )}
      <HomePageLayout>
        <AppStoreCallout />
      </HomePageLayout>
      <Footer
        citiesAndNeighborhoodsLinks={citiesAndNeighborhoodsLinks}
        countryFooterLinks={countryFooterLinks}
        countryRegionLinks={countryRegionLinks}
      />
    </>
  );
};

export default DefaultBrandHomePageTemplate;
